import { render } from "./App.vue?vue&type=template&id=7dd799d8&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7dd799d8&scoped=true&lang=scss"
import "./App.vue?vue&type=style&index=1&id=7dd799d8&lang=css"

import exportComponent from "/var/www/project/coridor-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd799d8"]])

export default __exports__